import { uploadFileToBase64String } from './../../../../../common/utils/utils';
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";
import { IUpdateEntregaObraClienteArquivoAuxUseCase } from '../../../presentation/useCases/update/update_entrega_obra_cliente_arquivo_aux_use_case';

/**
 * UpdateEntregaObraClienteArquivoAuxUseCase
 */

export class UpdateEntregaObraClienteArquivoAuxUseCase implements IUpdateEntregaObraClienteArquivoAuxUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idEntregaObraClienteArquivoAux: number,
    idEntregaObraCliente: number,
    descricao?: string,
    arquivo?: File,
    limparArquivo?: boolean

  ): Promise<void> {

    const computedNomeArquivo = arquivo ? arquivo.name : undefined;
    const computedArquivo = arquivo ? arquivo : undefined;

    await this.repository.updateEntregaObrasClienteArquivosAux(
      idEntregaObraClienteArquivoAux,
      idEntregaObraCliente,
      computedNomeArquivo,
      descricao,
      computedArquivo,
      limparArquivo
    );
  }
}
